import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeftSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.167 16.375 7 12m0 0 4.167-4.375M7 12h10"
    />
  </svg>
);
export default SvgArrowLeftSm;
